import React from 'react'
import { Field } from './Field'
import { Dropdown, Option } from '@fluentui/react-components'
import { Control, Controller } from 'react-hook-form'
import { Workplace } from '../../../api/schemas/schema'
import { t } from '../../../i18n/i18n'
import { ConditionalTooltip } from '../other/ConditionalTooltip'

type ControlledWorkplaceDropdownMultiProps = {
   name: any
   control: Control<any>
   label: string
   options: Workplace[]
   showTooltip?: boolean
   tooltipMsg?: string
   disabled?: boolean
   required?: boolean
}

export const ControlledWorkplaceDropdownMulti = ({
   name,
   control,
   label,
   options,
   disabled,
   required,
   showTooltip,
   tooltipMsg,
}: ControlledWorkplaceDropdownMultiProps) => {
   return (
      <Controller
         name={name}
         control={control}
         rules={{ required: required ? t('AtLeastOneWorkplaceMustBeSelected') : false }}
         render={({ field: { value, onChange }, fieldState: { error } }) => {
            return (
               <Field label={label} required={required ?? false} validationMessage={error?.message ?? null} validationState={error ? 'error' : null}>
                  <ConditionalTooltip show={showTooltip} content={tooltipMsg}>
                     <Dropdown
                        disabled={disabled ?? false}
                        multiselect
                        selectedOptions={Array.isArray(value) ? value.map((x) => x.id) : []}
                        value={
                           Array.isArray(value)
                              ? value
                                   .slice()
                                   .sort((a, b) => a.name.localeCompare(b.name))
                                   .map((x) => x.name)
                                   .join(', ')
                              : ''
                        }
                        onOptionSelect={(e, d) => {
                           const updated = d.selectedOptions.map((id) => options.find((x) => x.id === id)).filter((x): x is Workplace => !!x)
                           onChange(updated)
                        }}
                     >
                        {options.map((wp) => (
                           <Option key={wp.id} value={wp.id}>
                              {wp.name}
                           </Option>
                        ))}
                     </Dropdown>
                  </ConditionalTooltip>
               </Field>
            )
         }}
      />
   )
}
